import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { AuthProvider } from './providers/AuthProvider';
import RequireAuth from './RequireAuth.js';
import RequireRole from './providers/RequireRole';
// import Deathdetails from './ui-components/Deathdetails.js';
// import './axiosConfig';

const MasterLayout = lazy(() => import('./ui-components/MasterLayout'));
const Dashboard = lazy(() => import('./ui-components/Dashboard'));

const YearSettings = lazy(() => import('./ui-components/Year_settings'));
const ChangePassword = lazy(() => import('./ui-components/Change_password'));
const Parish = lazy(() => import('./ui-components/Parish'));
const Forane = lazy(() => import('./ui-components/Forane'));

const Administration = lazy(() => import('./ui-components/Administration'));
const CreateAdministration = lazy(() => import('./ui-components/CreateAdministration'));
const Data_Settings = lazy(() => import('./ui-components/Data_Settings'));
const Gallery = lazy(() => import('./ui-components/Gallery'));
const ChangePasswordUser = lazy(() => import('./ui-components/ChangePassword'));
const Login = lazy(() => import('./Login'));
const ResetPassword = lazy(() => import('./ResetPassword'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));

const UpdatePassword = lazy(() => import('./UpdatePassword'));
const Banner = lazy(() => import('./ui-components/Banner'));
const Scheme = lazy(() => import('./ui-components/Scheme'));
const CreateScheme = lazy(() => import('./ui-components/CreateScheme'));
const Beneficiary = lazy(() => import('./ui-components/Beneficiary.js'));
const CreateBeneficiary = lazy(() => import('./ui-components/CreateBeneficiary.js'));
const BeneficiaryDetails = lazy(() => import('./ui-components/BeneficiaryDetails.js'));
const RecentDonations = lazy(() => import('./ui-components/RecentDonations.js'));
const News = lazy(() => import('./ui-components/News'));
const Video = lazy(() => import('./ui-components/Video'));
const Quotes = lazy(() => import('./ui-components/Quotes'));
//reports
const BeneficiaryReport = lazy(() => import('./ui-components/reports/BeneficiaryReport'));
const DonationReport = lazy(() => import('./ui-components/reports/DonationReport'));
const DonorsList = lazy(() => import('./ui-components/DonorsList'));
const TotalFunds = lazy(() => import('./ui-components/TotalFunds'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-success" role="status"></div></div>}>
        <AuthProvider>
          <Routes>
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RequireAuth><MasterLayout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="banner" element={
                <RequireRole allowedRoles={['admin']}>
                  <Banner />
                </RequireRole>
              } />

              <Route path="year_setting" element={
                <RequireRole allowedRoles={['admin']}>
                  <YearSettings />
                </RequireRole>
              } />

              <Route path="change_password" element={
                <RequireRole allowedRoles={['admin']}>
                  <ChangePassword />
                </RequireRole>
              } />


              <Route path="parish" element={<RequireRole allowedRoles={['admin']}>

                <Parish />
              </RequireRole>

              } />
              <Route path="forane" element={<RequireRole allowedRoles={['admin']}>
                <Forane />
              </RequireRole>
              } />

              <Route path="administration" element={<RequireRole allowedRoles={['admin']}>
                <Administration />
              </RequireRole>
              } />

              <Route path="create-administration" element={<RequireRole allowedRoles={['admin']}>
                <CreateAdministration />
              </RequireRole>
              } />

              <Route path="create-team" element={<RequireRole allowedRoles={['admin']}>
                <CreateAdministration />
              </RequireRole>
              } />

              <Route path="datasettings" element={<RequireRole allowedRoles={['admin']}>
                <Data_Settings />
              </RequireRole>
              } />

              <Route path="news" element={
                <RequireRole allowedRoles={['admin']}>
                  <News />
                </RequireRole>
              } />

              <Route path="video" element={<RequireRole allowedRoles={['admin']}>

                <Video />
              </RequireRole>
              } />

              <Route path="quotes" element={<RequireRole allowedRoles={['admin']}>

                <Quotes />
              </RequireRole>
              } />

              <Route path="gallery" element={
                <RequireRole allowedRoles={['admin']}>
                  <Gallery />
                </RequireRole>
              } />

              <Route path="scheme" element={
                <RequireRole allowedRoles={['admin']}>
                  <Scheme />
                </RequireRole>
              } />

              <Route path="create-scheme" element={
                <RequireRole allowedRoles={['admin']}>
                  <CreateScheme />
                </RequireRole>
              } />

              <Route path="beneficiary" element={
                <RequireRole allowedRoles={['admin']}>
                  <Beneficiary />
                </RequireRole>
              } />

              <Route path="create-beneficiary" element={
                <RequireRole allowedRoles={['admin']}>
                  <CreateBeneficiary />
                </RequireRole>
              } />

              <Route path="beneficiary-details/:beneficiary_id" element={
                <RequireRole allowedRoles={['admin']}>
                  <BeneficiaryDetails />
                </RequireRole>
              } />

              <Route path="recent-donations" element={
                <RequireRole allowedRoles={['admin']}>
                  <RecentDonations />
                </RequireRole>
              } />


              <Route path="beneficiaries-report" element={
                <RequireRole allowedRoles={['admin']}>
                  <BeneficiaryReport />
                </RequireRole>
              } />

              <Route path="donations-report" element={
                <RequireRole allowedRoles={['admin']}>
                  <DonationReport />
                </RequireRole>
              } />

              <Route path="donors" element={
                <RequireRole allowedRoles={['admin']}>
                  <DonorsList />
                </RequireRole>
              } />

              <Route path="total-funds" element={
                <RequireRole allowedRoles={['admin']}>
                  <TotalFunds />
                </RequireRole>
              } />

              <Route path="changepassword" element={
                <RequireRole allowedRoles={['admin']}>
                  <ChangePasswordUser />
                </RequireRole>
              } />

            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>


  );
}

export default App;
